module.exports = __webpack_public_path__ + "static/media/celulares-passcoopeuch.ae07513f.png";